import { createContext, useContext, useSyncExternalStore } from 'react';

import type { ProjectStore } from '../domain/store.js';
import type { ProjectState } from '../domain/types.js';

export const StoreContext = createContext<ProjectStore | null>(null);

/** UI-chrome context: dialogs that any step can raise. */
export const UiContext = createContext<{ openLicenseDialog: () => void }>({
  openLicenseDialog: () => undefined,
});

export function useStore(): ProjectStore {
  const store = useContext(StoreContext);
  if (store === null) throw new Error('useStore outside StoreContext');
  return store;
}

export function useProjectState(): ProjectState {
  const store = useStore();
  return useSyncExternalStore(store.subscribe, store.getState, store.getState);
}

export function useOpenLicenseDialog(): () => void {
  return useContext(UiContext).openLicenseDialog;
}
